export default {
      id: "icon--circle-tick-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--circle-tick-usage",
      toString: function () {
        return this.url;
      }
    }